import InactiveTabModal from './InactiveTabModal';
export default InactiveTabModal;
